<div 
[class.rounded]="shape == 'rounded'"
[class.rectangle]="shape == 'rectangle'"
class="tag-wrapper">
    <div class="tag-name">
        <span class="title"> {{value}} </span>
         <br *ngIf="shape == 'rounded'">
         <span class="subtitle">OFF</span> 
    </div>
</div>